module.exports = __webpack_public_path__ + "static/media/airbnb.757921b3.png";